<template>
  <div
    v-show="loading"
    class="v-spinner"
  >
    <div class="v-beat v-beat-odd" />
    <div class="v-beat v-beat-even" />
    <div class="v-beat v-beat-odd" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingPulse',
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
})

</script>

<style scoped>

.v-spinner {
  height: 24px;
}

.v-spinner .v-beat {
  -webkit-animation: v-beatStretchDelay 0.7s infinite linear;
  animation: v-beatStretchDelay 0.7s infinite linear;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;         
}

.v-beat {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background-color: #000000;
}

.v-spinner .v-beat-odd {
  animation-delay: 0s;
}

.v-spinner .v-beat-even {
  animation-delay: 0.35s;
}

@-webkit-keyframes v-beatStretchDelay {
  50% {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
    -webkit-opacity: 0.2;             
    opacity: 0.2;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;             
    opacity: 1;
  }
}

@keyframes v-beatStretchDelay {
  50% {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
    -webkit-opacity: 0.2;             
    opacity: 0.2;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;             
    opacity: 1;
  }
}
</style>
